import { useMemo, useState } from "react";
import { Stack, Text, Group, Divider, SegmentedControl } from "@mantine/core";
import CardSection from "../../../shared/components/CardSection";
import BillRow from "../../finance/components/BillRow";
import { filterBills } from "../../finance/utils/billing";
import { FILTER_OPTIONS } from "../../finance/utils/constants";
import scClasses from "../../../shared/styles/mantine/segmented-control.module.css";

export default function LedgerPanel({
  bills = [],
  feeTypes = [],
  balanceDue = 0,
}) {
  const [filter, setFilter] = useState("due");

  const filteredBills = useMemo(
    () => filterBills(bills, filter),
    [bills, filter],
  );

  const feeTypeMap = useMemo(
    () => Object.fromEntries(feeTypes.map((fee) => [fee.id, fee])),
    [feeTypes],
  );

  return (
    <CardSection
      title="Danh sách hóa đơn chi tiết"
      footer={
        <>
          <Divider variant="dotted" mb="sm" />

          <Group justify="space-between" px={4}>
            <Text size="xs" fw={700} c="dimmed">
              TỔNG NỢ
            </Text>

            <Text
              size="xs"
              fw={900}
              c={balanceDue > 0 ? "red" : "var(--color-text)"}
            >
              {balanceDue.toLocaleString()} ₫
            </Text>
          </Group>
        </>
      }
    >
      <SegmentedControl
        size="xs"
        fullWidth
        value={filter}
        onChange={setFilter}
        data={FILTER_OPTIONS}
        mb="xs"
        classNames={{
          root: scClasses["base-control"],
          control: scClasses["control-item"],
          label: scClasses["control-label"],
          indicator: scClasses["control-indicator"],
        }}
      />

      <Stack gap="sm">
        {filteredBills.length ? (
          filteredBills.map((bill) => (
            <BillRow
              key={bill.id}
              bill={bill}
              feeType={feeTypeMap[bill.fee_id]}
            />
          ))
        ) : (
          <Text size="xs" c="dimmed" ta="center" py="sm">
            Không có hóa đơn
          </Text>
        )}
      </Stack>
    </CardSection>
  );
}
